<template>
  <section id="hero">
    <v-img
      :height="minHeight"
      :src="require('@/assets/bg2.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .3), rgba(5, 11, 31, .3)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center"
          height="70%"
          max-width="700"
          width="100%"
        >
          <base-heading title="Ship More, Save More" />

          <base-body style="font-size: 18px !important">
            A unified technology platform to digitize your logistic
            transportation.
          </base-body>

          <!-- <base-body style="font-size:18px !important">
            Use our freight ERP to digitize your day to day operation for more
            efficiency and cost saving.
          </base-body>

          <base-heading title="Freight Market" />

          <base-body style="font-size:18px !important">
            As a consigner or carrier, discover best rate transparently using
            our reverse auction engine. It's simple, reliable transparent and
            fast along with realtime tracking and secured delivery.
          </base-body>-->

          <div
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
            class="d-flex flex-wrap"
          >
            <v-row>
              <v-col>
                <v-btn color="orange" :to="'/shipper'">
                  <h3 class="text-none">Shipper</h3>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" :to="'/transporter'">
                  <h3 class="text-none">Transporter</h3>
                </v-btn>
              </v-col>
            </v-row>

            <!-- <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn :ripple="false" class="pa-1" height="auto" text>
              Get Started Now
            </base-btn>-->
          </div>
        </v-responsive>
        <div
          :class="
            $vuetify.breakpoint.smAndDown
              ? 'flex-column align-start'
              : 'align-center'
          "
          class="d-flex flex-wrap"
          style="width: 100%"
        >
          <v-row>
            <search-wizard />
          </v-row>
        </div>
      </v-container>
    </v-img>
  </section>
</template>

<script>
import SearchWizard from "./SearchWizard";
export default {
  name: "SectionHero",

  components: {
    // SearchWizard,
  },

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
